import { v4 as uuidv4 } from 'uuid';
export const addInitialVifPromptToMessagesList = (existingMessagesState) => {
    if (existingMessagesState.messages.length > 0) {
        const newMessage = {
            messageId: uuidv4(),
            question: '',
            response: 'Would you like me to visualize this for you?',
            isResponseCompleted: true,
        };
        return Object.assign(Object.assign({}, existingMessagesState), { messages: [...existingMessagesState.messages, newMessage] });
    }
    else {
        return existingMessagesState;
    }
};
export const findAndUpdateMessageResponse = (messagesList, updatedMessage) => {
    return messagesList.map(message => {
        if (message.messageId === updatedMessage.messageId) {
            return Object.assign(Object.assign({}, message), { response: message.response.concat(updatedMessage.responseChunk), isResponseCompleted: updatedMessage.isResponseCompleted });
        }
        return message;
    });
};
export const findAndClearMessageResponse = (messagesList, messageId) => {
    return messagesList.map(message => {
        if (message.messageId === messageId) {
            return Object.assign(Object.assign({}, message), { response: '' });
        }
        return message;
    });
};
//# sourceMappingURL=messages.js.map